<template>
    <LongitudinalPeakAnalysis :sessions="sessions" :rainbowData="rainbowData"
        :rainbowComparisonData="rainbowComparisonData" :peakEpochCountData="peakEpochCountData"
        :peakEpochCountComparisonData="peakEpochCountComparisonData" :kpiOptions="kpiOptions"
        :referenceText="selectedReferenceGroupText" :positionReferenceText="positionReferenceGroupText">
        <template #shared-info>
            <SharedInfoText />
        </template>
        <template #rainbow-legend>
            <LongitudinalChartLegend class="w-100 w-lg-25 mx-auto" :referenceGroupText="positionReferenceGroupText"
                :displayComparisonKeys="false" />
        </template>
        <template #peak-counts-legend>
            <LongitudinalChartLegend :referenceGroupText="positionReferenceGroupText" />
        </template>
    </LongitudinalPeakAnalysis>
</template>

<script>
import filterStore from './filterStore';
import { positionReferenceGroupText, selectedReferenceGroupText } from "./referenceGroupText";
import SharedInfoText from "./SharedInfoText";

export default {
    props: {
        sessions: Array,
        rainbowData: Object,
        rainbowComparisonData: Object,
        peakEpochCountData: Object,
        peakEpochCountComparisonData: Object,
    },
    components: {
        SharedInfoText
    },
    computed: {
        kpiOptions() {
            return filterStore.state.kpiOptions;
        },
        selectedReferenceGroupText() {
            return selectedReferenceGroupText();
        },
        positionReferenceGroupText() {
            return positionReferenceGroupText();
        }
    },
};
</script>
